import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {ProductSummaryModel} from '../productSummary.model';
import {LovValueSummaryConverter} from '../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {DocumentSummaryConverter} from '../../../../document/common/api/converter/DocumentSummary.converter';
import {Injectable} from '@angular/core';

@Injectable()
export class ProductSummaryConverter extends HttpModelConverter<ProductSummaryModel> {

    constructor(private lovValueSummaryConverter: LovValueSummaryConverter,
                private documentSummaryConverter: DocumentSummaryConverter) {
        super();
    }

    protected createInstance(): ProductSummaryModel {
        return new ProductSummaryModel();
    }

    protected enrichObject(result: ProductSummaryModel, src: ProductSummaryModel) {
        result.category = this.lovValueSummaryConverter.convert(src.category);
        result.color = this.lovValueSummaryConverter.convert(src.color);
        result.image = this.documentSummaryConverter.convert(src.image);
    }

}
